import { updateAiPermission } from 'users'

export const updateUserStatus = async (userId: string, type: string) => {
  try {
    if (userId) {
      const permission = type === 'add'
      const changeAiPermissionResponse: any = await updateAiPermission(userId, permission)
      if (changeAiPermissionResponse?.updateUsers?.returning.length === 1) {
        return { status: true }
      } else {
        return { error: true }
      }
    }
  } catch (err) {
    console.log(err, 'error is this')
  }
}